<template>
	<div class="chart-filter-bar">
		<slot name="header" />
		<div class="chart-filter-bar__filters">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts" />

<style lang="scss" scoped>
.chart-filter-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1.125rem 3rem;
	gap: 2rem;

	&__filters {
		display: flex;
		gap: 3rem;
		align-items: center;
		margin-left: auto;
	}
}
</style>
